export default {
    outlook: "Open Outlook",
    gmail: "Open Gmail",
    yahoo: "Open Yahoo",
};
